import { render, staticRenderFns } from "./AppointmentCalendarSlotButtons.vue?vue&type=template&id=54b9ab53&scoped=true&"
import script from "./AppointmentCalendarSlotButtons.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppointmentCalendarSlotButtons.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AppointmentCalendarSlotButtons.vue?vue&type=style&index=0&id=54b9ab53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b9ab53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b9ab53')) {
      api.createRecord('54b9ab53', component.options)
    } else {
      api.reload('54b9ab53', component.options)
    }
    module.hot.accept("./AppointmentCalendarSlotButtons.vue?vue&type=template&id=54b9ab53&scoped=true&", function () {
      api.rerender('54b9ab53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentCalendar/components/AppointmentCalendarSlotButtons.vue"
export default component.exports